function TableSearch({ onSearch }) {
  let input;
  const handleChange = () => {
    onSearch(input.value);
  };
  return (
    <div className="Search-container">
      <span>Buscar</span>
      <input className="form-control" style={{ width: '250px' }} ref={(n) => (input = n)} onChange={handleChange} />
    </div>
  );
}

export default TableSearch;
